<div class="cx-page" *ngIf="model$ | async as model">
  <section tabindex="-1" class="cx-page-section" [attr.aria-label]="'productList.productListResults' | cxTranslate">
    <div class="container" [ngClass]="{'has-results': model?.products?.length}">
      <div class="row">
        <div class="col-12 col-lg-12" *ngIf="(results$ | async).pagination.totalResults > 0; else noResults">
          <div class="cx-sorting top pb-3 border-bottom mb-4">
            <div class="row flex-column">
              <div class="results" *ngIf="(templateName$ | async) == 'SearchResultsListPageTemplate'">
                <h1>Has buscado "{{ model.freeTextSearch }}"</h1>
              </div>
              <div class="row flex-row drops">
                <div class="label-sort mt-4" *ngIf="(results$ | async).pagination?.totalResults">
                  <label class="form-group cx-sort-dropdown col-12 col-lg-4 mr-auto">
                    <app-custom-sorting
                      [sortOptions]="model.sorts"
                      (sortListEvent)="sortList($event)"
                      [selectedOption]="model.pagination?.sort"
                      [ariaLabel]="'productList.sortResults' | cxTranslate"
                      ariaControls="product-results-list"
                      placeholder="{{ 'productList.sortBy' | cxTranslate }}"
                    ></app-custom-sorting>
                  </label>
                </div>
                <div class="col-auto mt-4" style="align-self: center">
                  <div class="cx-pagination" [attr.aria-label]="'productList.productSearchPagination' | cxTranslate">
                    <app-custom-pagination
                      [pagination]="model.pagination"
                      queryParam="currentPage"
                      [defaultPage]="0"
                      (viewPageEvent)="pageChange()"
                    ></app-custom-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="product-results-list" class="cx-product-container">
            <div class="col-xs-12 found-products">
              <div>{{ model.pagination.totalResults | number: '1.0-0' }} <span>productos</span> encontrados</div>
            </div>
            <ng-container>
              <div class="row">
                <custom-product-list-item
                  *ngFor="let product of model?.products"
                  [product]="product"
                  class="col-12 col-sm-6 col-md-3 text-center"
                >
                </custom-product-list-item>
              </div>
            </ng-container>
          </div>
          <div class="cx-sorting bottom mt-4" *ngIf="(results$ | async).pagination.totalResults">
            <div class="row flex-row drops">
              <div class="label-sort mt-4" *ngIf="(results$ | async).pagination?.totalResults">
                <label class="form-group cx-sort-dropdown col-12 col-lg-4 mr-auto">
                  <app-custom-sorting
                    [sortOptions]="model.sorts"
                    (sortListEvent)="sortList($event)"
                    [selectedOption]="model.pagination?.sort"
                    [ariaLabel]="'productList.sortResults' | cxTranslate"
                    ariaControls="product-results-list"
                    placeholder="{{ 'productList.sortBy' | cxTranslate }}"
                  ></app-custom-sorting>
                </label>
              </div>
              <div class="col-auto mt-4" style="align-self: center">
                <div class="cx-pagination" [attr.aria-label]="'productList.productSearchPagination' | cxTranslate">
                  <app-custom-pagination
                    [pagination]="model.pagination"
                    queryParam="currentPage"
                    (viewPageEvent)="pageChange()"
                    [defaultPage]="0"
                  ></app-custom-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <ng-template #noResults>
          <div class="d-flex no-results">
            <div class="text-no-results">
              {{ model.pagination.totalResults }} elementos encontrados para palabra clave <strong>{{ model.freeTextSearch }}</strong>
            </div>
            <a class="error-btn" routerLink="/"> Continuar comprando</a>
          </div>
        </ng-template>
      </div>
    </div>
  </section>
</div>
